// Aborts middleware queue if ctx has a statusCode that not in the 200 range
function withCtxAbortOnStatusCode() {
  return (ctx, next) => {
    if (ctx.statusCode && ctx.statusCode >= 299 || ctx.statusCode <= 199) {
      next(`aborting ctx-middlware queue: ctx has been assigned a ${ctx.statusCode} status code`);
    }
  };
}

export { withCtxAbortOnStatusCode };
